// extracted by mini-css-extract-plugin
module.exports = {"svgWrapper":"Svg-module--svgWrapper--1qyKy"};